import service from "@/api/service";
import { GetResponse } from "@/api/app-transition/response";
import { GetRequest } from "@/api/app-transition/request";

/**
 * アプリレイアウト情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-app-transition", getRequest);
  return response.data as GetResponse;
}
